import { Granularity } from "../../types";
import { useDashboardContext } from "../../hooks/use-dashboard-context";
import { FilterSelect } from "src/@/components/ui/filter-select";
import { Button } from "src/@/components/ui/button";
import { t } from "@lingui/core/macro";

type GranularityOption = {
    value: Granularity;
    label: string;
};

export const DashboardGranularityPicker = () => {
    const { granularity, setGranularity } = useDashboardContext();

    const options: GranularityOption[] = [
        { value: Granularity.DAY, label: t`Daily` },
        { value: Granularity.WEEK, label: t`Weekly` },
        { value: Granularity.MONTH, label: t`Monthly` },
        { value: Granularity.YEAR, label: t`Yearly` },
    ];

    return (
        <FilterSelect
            selectedValues={new Set([granularity])}
            customButton={
                <Button variant="outline" size="sm">
                    {options.find((opt) => opt.value === granularity)?.label}
                </Button>
            }
            title={t`Granularity`}
            onOptionSelected={(value) => setGranularity(value as Granularity)}
            options={options}
        />
    );
};
